import _ from "lodash";

require('../../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../../ComponentSet";
import utils        from "../../../Utils";
import moment       from 'moment';
import Constants    from "../../../Constants";
import Swiper, {Autoplay, EffectFade, Navigation, Pagination} from "swiper";

// import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

const components = _.merge(ComponentSet,
    {
        'medical-service-chart': () => import('./components/MedicalServiceChart.vue'),
        //'Latest': () => import('./components/Latest.vue'),
        //'Award' : () => import('./components/Award.vue' ),
    });

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: {
        medicalServiceChartData: {
            labels: [], datasets: [] 
        },
        outpatientVisitsChartData: {
            labels: [], datasets: [] 
        },
        emergencyRoomVisitsChartData: {
            labels: [], datasets: [] 
        },
        numberOfInpatientsChartData: {
            labels: [], datasets: [] 
        },
        deviceWidth: 0
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
        this.deviceWidth = window.innerWidth;
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function() {
            
            self.$nextTick(function() {
                
                // banner initialize
                const banner_swiper = new Swiper(".banner_swiper", {
                                            // configure Swiper to use modules
                                            modules: [Navigation, Autoplay, EffectFade],
                                            // Optional parameters
                                            loop: true,
                                            effect: 'fade',
                                            autoplay:true,
                                            // Navigation arrows
                                            navigation: {
                                                nextEl: ".banner-button-next",
                                                prevEl: ".banner-button-prev",
                                            },
                                            on: {
                                                slideChange:function(swiper){
                                                    $('.banner_swiper .scroll-txt h3').hide();
                                                    $('.banner_swiper .scroll-txt h3').eq(swiper.realIndex).show()
                                                }
                                            }
                                        }); // end of swiper
                this.buildNumberOfMedicalServicesData;
                this.buildOutpatientVisitsData;
                this.buildEmergencyRoomVisitsData;
                this.buildONumberOfInpatientsData;
            });
        });        
    },
    methods: {
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        bannersData() {
            return _.get(this, 'contentData.bannerList', []) || [];
        },
        buildNumberOfMedicalServicesData(){
            //this.medicalServiceChartData = {
            //    labels: [ '2016', '2017', '2018' ],
            //    datasets: [
            //        {
            //            label: 'Data One',
            //            backgroundColor: '#ff0000',
            //            data: [40, 20, 11]
            //        },
            //        {
            //            label: 'Data two',
            //            backgroundColor: '#00ff00',
            //            data: [30, 20, 12]
            //        },
            //        {
            //            label: 'Data three',
            //            backgroundColor: '#0000ff',
            //            data: [20, 20, 13]
            //        }
            //    ]
            //}
            let numberOfMedicalServiceYearLabelList = _.get(this, 'contentData.numberOfMedicalServices.labels', []) || [];
            let numberOfMedicalServiceDataset       = _.get(this, 'contentData.numberOfMedicalServices.datasets', []) || [];

            this.medicalServiceChartData = {
                labels: numberOfMedicalServiceYearLabelList,
                datasets: numberOfMedicalServiceDataset
            }
        },
        buildOutpatientVisitsData(){
            let outpatientVisitsYearLabelList = _.get(this, 'contentData.outpatientVisits.labels', []) || [];
            let outpatientVisitsDataset       = _.get(this, 'contentData.outpatientVisits.datasets', []) || [];

            this.outpatientVisitsChartData = {
                labels: outpatientVisitsYearLabelList,
                datasets: outpatientVisitsDataset
            }
        },
        buildEmergencyRoomVisitsData(){
            let emergencyRoomVisitsYearLabelList = _.get(this, 'contentData.emergencyRoomVisits.labels', []) || [];
            let emergencyRoomVisitsDataset       = _.get(this, 'contentData.emergencyRoomVisits.datasets', []) || [];

            this.emergencyRoomVisitsChartData = {
                labels: emergencyRoomVisitsYearLabelList,
                datasets: emergencyRoomVisitsDataset
            }
        },
        buildONumberOfInpatientsData(){
            let numberOfInpatientsYearLabelList = _.get(this, 'contentData.numberOfInpatients.labels', []) || [];
            let numberOfInpatientsDataset       = _.get(this, 'contentData.numberOfInpatients.datasets', []) || [];

            this.numberOfInpatientsChartData = {
                labels: numberOfInpatientsYearLabelList,
                datasets: numberOfInpatientsDataset
            }
        }
    }, // end of computed
}).$mount('#app');